import { render, staticRenderFns } from "./household_tabs.vue?vue&type=template&id=40dfab88"
import script from "./household_tabs.vue?vue&type=script&lang=js"
export * from "./household_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports